import { 
    Flex, 
    Text, 
    Image
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

const ImageCarrousel = ({ images, overrideStyle }) => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            nextImage();
        }, 5000);
        return () => clearInterval(interval);
    }, [currentImage]);

    const nextImage = () => {
        if (currentImage + 1 >= images.length) {
            setCurrentImage(0);
        } else {
            setCurrentImage(currentImage + 1);
        }
    }

    const previosImage = () => {
        if (currentImage - 1 < 0) {
            setCurrentImage(images.length - 1);
        } else {
            setCurrentImage(currentImage - 1);
        }
    }

    return (
        <Flex
            w={'100%'}
            minH={{
                base: '300px',
                md: '500px',
            }}
            bg={'gray.100'}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            zIndex={1}
            position={'relative'}
            {...overrideStyle}
        >
            {images && images.length > 0 ? (
                <Flex
                    flex={1}
                    w={'100%'}
                    maxH={'500px'}
                    h={'500px'}
                    bg={'gray.100'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    flexDirection={'column'}
                    position={'relative'}
                    zIndex={1}
                >
                    <Flex
                        w={'100%'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        flexDirection={'row'}
                        position={'absolute'}
                        bottom={2}
                        zIndex={1000}
                    >
                        {
                            images.map((image, index) => (
                                <Flex 
                                    key={index}
                                    w={'10px'}
                                    h={'10px'}
                                    bg={index === currentImage ? 'gray.500' : 'gray.300'}
                                    borderRadius={'50%'}
                                    m={'5px'}
                                    cursor={'pointer'}
                                    onClick={() => setCurrentImage(index)}
                                />
                            ))
                        }
                    </Flex>
                    <Flex 
                        w='50%'
                        h='100%'
                        maxH={'500px'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        flexDirection={'column'}
                        position={'absolute'}
                        left={'0'}
                        zIndex={'1'}
                        onClick={previosImage}
                        cursor={'pointer'}
                    />
                    <Flex 
                        w='50%'
                        h='100%'
                        maxH={'500px'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        flexDirection={'column'}
                        position={'absolute'}
                        right={'0'}
                        zIndex={'1'}
                        onClick={nextImage}
                        cursor={'pointer'}
                    />
                    <Image 
                        draggable={false}
                        maxH={'500px'}
                        src={images[currentImage].url}
                        objectFit={'cover'}
                        alt={images[currentImage].alt}
                    />
                </Flex>
            ) : (
                <Flex
                    w={'100%'}
                    h={'100%'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    flexDirection={'column'}
                >
                    <Text>Provide Images</Text>
                </Flex>
            )}
        </Flex>
    )
}

export default ImageCarrousel;